import { fetchWithAuth } from "./fetchWithAuth";

const PROD_APP_URL = process.env.REACT_APP_PROD_APP_URL || "";
const API_URL = process.env.REACT_APP_API_URL || "";
const DEV_API_URL = process.env.REACT_APP_DEV_API_URL || "";
const PROD_API_URL = process.env.REACT_APP_PROD_API_URL || "";

const APP_URL = process.env.REACT_APP_APP_URL || "";
const DEV_APP_URL = process.env.REACT_APP_DEV_APP_URL || "";

const apiBaseUrl =
  window.location.hostname === "localhost"
    ? API_URL
    : window.location.hostname === new URL(PROD_APP_URL).hostname
      ? PROD_API_URL
      : DEV_API_URL;

const siteBaseUrl =
  window.location.hostname === "localhost"
    ? APP_URL
    : window.location.hostname === new URL(PROD_APP_URL).hostname
      ? PROD_APP_URL
      : DEV_APP_URL;

export const generateCertifiedMail = async (
  referenceDetailIDs: number[],
): Promise<Response | null> => {
  try {
    const response = await fetchWithAuth(
      `${apiBaseUrl}/api/Report/GenerateCertifiedMail`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ referenceDetailIDs }),
      },
    );

    if (!response.ok) throw new Error("Failed to generate Certified Mail CSV");

    return response;
  } catch (error) {
    console.error("Error generating certified mail csv:", error);
    return null;
  }
};

export const generateCloseFileReport = async (): Promise<Response | null> => {
  try {
    const response = await fetchWithAuth(
      `${apiBaseUrl}/api/Report/GenerateCloseFileReport`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      },
    );

    if (!response.ok)
      throw new Error("Failed to generate incomplete status report");

    return response;
  } catch (error) {
    console.error("Error generating incomplete status report:", error);
    return null;
  }
};

export const batchSendLetters = async (
  referenceDetailIDs: number[],
): Promise<Response | null> => {
  try {
    const formData = {
      referenceDetailIDs,
      baseUrl: siteBaseUrl,
    };

    const token = localStorage.getItem("token");
    if (!token) {
      throw new Error("User is not authenticated");
    }

    const response = await fetchWithAuth(
      `${apiBaseUrl}/api/Report/BatchSendLetters`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(formData),
      },
    );

    if (!response.ok) throw new Error("Failed to bulk send letters.");

    return response;
  } catch (error) {
    console.error("Error to bulk send letters", error);
    return null;
  }
};

export interface BatchSendResult {
  success: boolean;
  errorMessage?: string;
}

export const batchSendCertifiedLetters = async (
  referenceDetailIDs: number[],
): Promise<Response | null> => {
  try {
    const formData = {
      referenceDetailIDs,
      baseUrl: siteBaseUrl,
    };

    const token = localStorage.getItem("token");
    if (!token) {
      throw new Error("User is not authenticated");
    }

    const response = await fetchWithAuth(
      `${apiBaseUrl}/api/Report/BatchSendCertifiedLetters`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(formData),
      },
    );

    return response;
  } catch (error) {
    console.error("Error to bulk send certified letters", error);
    return null;
  }
};
